import axios from 'axios'
import qs from 'qs'
import router from '@/router.js'
import docCookies from '@/utils/docCookies.js'

// axios 配置
axios.defaults.baseURL = `${window.location.origin}/api/v1`
axios.defaults.timeout = 5000

// http request 拦截器
axios.interceptors.request.use(
  config => {
    if (docCookies.hasItem('vsat-iam')) {
      config.headers.Authorization = docCookies.getItem('vsat-iam')
    }
    return config
  },
  err => {
    return Promise.reject(err)
  }
)

// http response 拦截器
axios.interceptors.response.use(
  response => {
    return response
  },
  error => {
    if (error.response) {
      switch (error.response.status) {
        case 401:
          // 401 清除token信息并跳转到登录页面
          docCookies.removeItem(
            'vsat-iam',
            '/',
            window.location.host.split('.').slice(-2).join('.')
          )
          localStorage.clear()

          // 只有在当前路由不是登录页面才跳转
          router.currentRoute.path !== 'login' &&
            router.replace({
              path: 'login',
              query: { redirect: router.currentRoute.path }
            })
      }
    }
    // console.log(JSON.stringify(error));//console : Error: Request failed with status code 402
    return Promise.reject(error.response)
  }
)

axios.defaults.paramsSerializer = params => {
  return qs.stringify(params, { arrayFormat: 'comma' })
}

export default axios
